import { Component, HostListener, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { DeclarationService } from '../declaration/declaration.service';
import { BallotListService } from '../ballot-list/ballot-list.service';
import { ScreenOrderService } from '../Services/screen-order.service';
import { ApiAboutService } from '../Services/api-about.service';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
    selector: 'app-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss'],
    standalone: false
})
export class ProgressBarComponent implements OnChanges , OnInit{
  stepIndex: number = 0
  @ViewChild('stepper') stepper: MatStepper | undefined
  @Input() routeName = ""

  progressSteps: Array<Steps> = [
    { route: "/home",           description: $localize`Verify`,       enable: true },
    { route: "/verifymfa",      description: $localize`Code`,         enable: false },
    { route: "/declaration",    description: $localize`Declaration`,  enable: false },
    { route: "/return-options", description: $localize`Options`,      enable: false },
    { route: "/id-upload",      description: $localize`ID`,           enable: false },
    { route: "/headshot-upload",description: $localize`Selfie`,       enable: false },
    { route: "/ballot-list",    description: $localize`Ballots`,      enable: false },
    { route: "/dashboard",      description: $localize`Dashboard`,    enable: false },
    { route: "/ballot",         description: $localize`Vote`,         enable: true },
    { route: "/petition",       description: $localize`Petition`,     enable: false },
    { route: "/review",         description: $localize`Review`,       enable: true },
    { route: "/print-page",     description: $localize`Print`,        enable: false },
    { route: "/signature",      description: $localize`Sign`,         enable: false },
    { route: "/vote-success",   description: $localize`Complete`,     enable: true },
  ];
  isMobileScreen = this.breakpointObserver.isMatched('(max-width: 599px)');
 
  constructor(private readonly declarationService: DeclarationService,
              private readonly ballotListService: BallotListService,
              private readonly screenOrder: ScreenOrderService,
              readonly about: ApiAboutService,
              private breakpointObserver: BreakpointObserver,
  ){
    if(this.about.idUploadFlow) {
      let thisStep = this.progressSteps.find(step => step.route == '/home');
      if(thisStep){
        thisStep.description = $localize`Onboard`;
      }
    }
    if(this.about.isIDVflow()){
      let thisStep = this.progressSteps.find(step => step.route == '/verifymfa');
      if(thisStep){
        thisStep.enable = true;
      }
    }
    if(this.declarationService.required){
      let thisStep = this.progressSteps.find(step => step.route == '/declaration');
      if(thisStep){
        thisStep.enable = true;
      }
    }

    if(this.screenOrder.voterBallotType === "ELECTRONICORPRINT"){
      let thisStep = this.progressSteps.find(step => step.route == "/return-options");
      if(thisStep){
        thisStep.enable = true;
      }
    }

    if(this.about.isIDVflow()) {
      let idStep = this.progressSteps.find(step => step.route == "/id-upload");
      if(idStep){
        idStep.enable = true;
      }
      let headshotStep = this.progressSteps.find(step => step.route == "/headshot-upload");
      if(headshotStep){
        headshotStep.enable = true;
      }
      let thisStep = this.progressSteps.find(step => step.route == '/dashboard');
        if(thisStep){
          thisStep.enable = true;
        }
    } else {
      let ballotList = this.ballotListService.getBallots();
      if(ballotList.length > 1) {
        let thisStep = this.progressSteps.find(step => step.route == '/ballot-list');
        if(thisStep){
          thisStep.enable = true;
        }
      }

      if(ballotList.length == 1 && ballotList[0].eventType?.toLowerCase() === 'petition') {
        let oldStep = this.progressSteps.find(step => step.route == '/ballot');
        if(oldStep){
          oldStep.enable = false;
        }
        let thisStep = this.progressSteps.find(step => step.route == '/petition');
        if(thisStep){
          thisStep.enable = true;
        }
      }
    }

    if(this.screenOrder.selectedReturnMethod === "PRINT"){
      let thisStep = this.progressSteps.find(step => step.route == "/print-page");
      if(thisStep){
        thisStep.enable = true;
      }
      let lastStep = this.progressSteps.find(step => step.route == "/vote-success");
      if(lastStep){
        lastStep.enable = false;
      }
    }

    if(this.screenOrder.selectedReturnMethod === 'ELECTRONIC' && this.about.signatureRequired.getValue() && this.screenOrder.returnMethodSelected){
      let thisStep = this.progressSteps.find(step => step.route == "/signature");
      if(thisStep){
        thisStep.enable = true;
      }
    }
  }

  ngOnInit() {
    this.isMobileScreen = this.breakpointObserver.isMatched('(max-width: 599px)');
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobileScreen = this.breakpointObserver.isMatched('(max-width: 599px)');
  }

  get enabledSteps(){
    return this.progressSteps.filter(step => step.enable)
  }

  get currentDescription(): string {
    return this.enabledSteps[this.stepIndex]?.description || '';
  }

  ngOnChanges(changes: SimpleChanges) {
    const routeName = this.routeName.split("?")[0];
    this.stepIndex = this.enabledSteps.findIndex(step => step.route === routeName);
    if(this.stepIndex == -1) { 
      this.stepIndex = 0;
    }
  
    if (this.stepper && this.stepper.selected) {
      if (this.stepIndex >= 0 && this.stepIndex < this.stepper.steps.length) {
        for (let i = 0; i < this.stepIndex; i++) {
          this.stepper.selectedIndex = i;
          this.stepper.selected.completed = true;
        }
        this.stepper.selectedIndex = this.stepIndex;  
      } else {
        console.error('stepIndex out of bounds:', this.stepIndex);
      }
    }
  }
}

interface Steps {
  route: string;
  description: string;
  enable: boolean;
}